// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-plan-details-index-jsx": () => import("./../../../src/pages/PlanDetails/index.jsx" /* webpackChunkName: "component---src-pages-plan-details-index-jsx" */),
  "component---src-pages-route-js": () => import("./../../../src/pages/Route.js" /* webpackChunkName: "component---src-pages-route-js" */)
}

